<lib-chart-scatter #ChartWrapper disableLegend [chartConf]="conf"/>